import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Heart, Play, ChevronRight } from "lucide-react";
import api from "../lib/api";

const Landing = () => {
  const nav = useNavigate();
  const [quote, setQuote] = useState("");
  useEffect(() => {
    // If already logged in, jump to dashboard
    if (localStorage.getItem("hc_token")) nav("/dashboard", { replace: true });
    api.get("/public/quote").then((r) => setQuote(r.data?.quote || "")).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-[100dvh] px-6 pt-12 pb-8 flex flex-col relative overflow-hidden">
      {/* Decorative shapes */}
      <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-[#F4844B]/20 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-64 h-64 rounded-full bg-[#0A4C36]/10 blur-3xl" />

      <div className="relative z-10 flex-1 flex flex-col">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-10 h-10 rounded-2xl bg-gradient-to-br from-[#F4844B] to-[#EF4444] flex items-center justify-center shadow-lg shadow-[#F4844B]/30">
            <Heart size={20} className="text-white" fill="white" />
          </div>
          <span className="font-instrument text-xl font-semibold text-[#0A4C36]">Health Circles</span>
        </div>

        <div className="flex-1 flex flex-col justify-center">
          <p className="text-sm uppercase tracking-widest text-[#F4844B] font-medium mb-3">Your wellness pocket</p>
          <h1 className="font-instrument text-5xl font-semibold text-[#0A4C36] leading-[1.05] mb-4">
            Care that<br /> travels with<br /> <span className="text-[#F4844B]">you.</span>
          </h1>
          <p className="text-base text-[#57534E] leading-relaxed mb-8">
            Track vitals, join consultations, and stay connected to your care circle — beautifully, simply.
          </p>
          {quote && (
            <div className="rounded-3xl p-4 bg-white/60 backdrop-blur border border-white mb-8">
              <p className="font-instrument text-sm italic text-[#0A4C36]" data-testid="landing-quote">&ldquo;{quote}&rdquo;</p>
            </div>
          )}
        </div>

        <div className="flex flex-col gap-3 relative z-10">
          <Link to="/signup" data-testid="landing-signup" className="btn-primary text-center no-underline flex items-center justify-center gap-2">
            Get started <ChevronRight size={18} />
          </Link>
          <Link to="/login" data-testid="landing-login" className="btn-secondary text-center no-underline">
            I already have an account
          </Link>
          <Link to="/awareness" data-testid="landing-awareness" className="text-center text-sm text-[#0A4C36] font-medium mt-2 no-underline flex items-center justify-center gap-1.5">
            <Play size={14} /> Explore health awareness first
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Landing;
